import React from "react";
import { Helmet } from "react-helmet-async";

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Luxuriya Homes - Luxury Interior Design</title>
        <meta 
          name="description" 
          content="Read the Terms and Conditions of Luxuriya Homes. We ensure transparency, trust, and professional excellence in our luxury interior design services." 
        />
        <meta 
          name="keywords" 
          content="Terms and Conditions, Luxuriya Homes Policy, Interior Design Contracts, Luxury Interiors India" 
        />
        <link rel="canonical" href="https://www.luxuriyahomes.com/terms-and-conditions" />
      </Helmet>

      <div className="bg-neutral-50 min-h-screen text-neutral-800 font-sans">
        
        {/* HERO / HEADER */}
        <header
          className="relative h-[50vh] md:h-[65vh] flex items-center justify-center text-white"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black/70"></div>

          {/* Content */}
          <div className="relative z-10 text-center px-4 md:px-6">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif tracking-widest text-[#D4AF37] mb-4">
              Terms & Conditions
            </h1>

            <div className="w-24 md:w-32 h-[2px] bg-[#D4AF37] mx-auto mt-6 md:mt-8 mb-8 md:mb-10"></div>

            <p className="max-w-xl md:max-w-2xl mx-auto text-neutral-300 text-base md:text-lg leading-relaxed px-2">
              Transparency, trust aur professional excellence ko ensure karne ke liye
              ye terms design kiye gaye hain.
            </p>
          </div>
        </header>

        {/* CONTENT */}
        <main className="max-w-5xl mx-auto px-4 md:px-6 py-12 md:py-20">
          
          {/* INTRO */}
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-20">
            <p className="text-base md:text-lg leading-loose text-neutral-600">
              Welcome to{" "}
              <span className="font-semibold text-black">
                Luxuriya Homes
              </span>.  
              Hamara goal aapko ek refined, transparent aur world-class luxury
              interior experience dena hai. Niche diye gaye terms hamare
              professional standards aur mutual trust ko ensure karte hain.
            </p>
          </div>

          {/* SECTIONS */}
          <div className="space-y-8 md:space-y-12">
            <Section title="1. Services & Scope">
              Luxuriya Homes end-to-end interior design solutions provide karta
              hai. Saare designs aur 3D renders tab tak hamari intellectual
              property rahenge jab tak project ki full payment clear nahi ho
              jaati. Execution strictly final approved drawings ke according
              hoga.
            </Section>

            <Section title="2. Payment Policy">
              <ul className="list-disc pl-5 md:pl-6 space-y-2 md:space-y-3">
                <li>
                  <strong>Booking Amount:</strong> Project confirmation ke liye
                  10% advance mandatory hai.
                </li>
                <li>
                  <strong>Design Phase:</strong> 40% payment design finalization
                  se pehle due hogi.
                </li>
                <li>
                  <strong>Execution Phase:</strong> Remaining payment agreed
                  milestones ke according collect ki jayegi.
                </li>
                <li>
                  Delayed payments project timeline ko impact kar sakti hain.
                </li>
              </ul>
            </Section>

            <Section title="3. Design Revisions">
              Har project ke saath hum{" "}
              <strong>3 Major Design Revisions</strong> complimentary dete hain.
              Uske baad ke changes additional cost ke saath process kiye jaate
              hain.
            </Section>

            <Section title="4. Timelines & Delays">
              Hum committed timelines follow karte hain, lekin external factors
              jaise material availability, permissions ya site conditions ke
              kaaran hone wale delays ke liye Luxuriya Homes responsible nahi
              hoga.
            </Section>

            <Section title="5. Warranty & Maintenance">
              Custom furniture aur woodwork par{" "}
              <strong>5 Years Manufacturing Warranty</strong> applicable hoti
              hai. Electrical fittings, fabrics aur appliances ki warranty
              respective manufacturers ke terms par depend karegi.
            </Section>
          </div>

          {/* FOOTER NOTE */}
          <div className="mt-16 md:mt-24 pt-10 border-t border-neutral-200 text-center text-sm text-neutral-500">
            <p>Last Updated: January 2026</p>
            <p className="mt-3">
              Queries ke liye contact karein:{" "}
              <a
                href="mailto:support@luxuriyahomes.com"
                className="text-[#D4AF37] hover:underline"
              >
                support@luxuriyahomes.com
              </a>
            </p>
          </div>
        </main>
      </div>
    </>
  );
};

/* SECTION COMPONENT */
type SectionProps = {
  title: string;
  children: React.ReactNode;
};

const Section: React.FC<SectionProps> = ({ title, children }) => (
  <section className="bg-white rounded-xl p-6 md:p-10 shadow-[0_10px_40px_rgba(0,0,0,0.06)] border-l-4 border-[#D4AF37]">
    <h2 className="text-xl md:text-3xl font-serif text-black mb-4 md:mb-5">
      {title}
    </h2>
    <div className="text-neutral-600 leading-relaxed text-sm md:text-[15px]">
      {children}
    </div>
  </section>
);

export default TermsAndConditions;